import React, { Fragment } from 'react';
import { FieldProps } from 'formik';
import { map } from 'lodash';
import { NetworkStatus, useQuery } from '@apollo/client';
import { BlockType } from '@bechtel/types';
import { Text } from '@bechtel/gds';
import { Radio, Box, Spinner, SpinnerSize, Set, SetSpacing, SetDirection } from '@bechtel/gds';
import { GET_BLOCK_TYPES } from '@bechtel/client-gql';
import { ErrorRetry, ListSelectionStyled } from '@bechtel/client-common';
import { BlockTypeMessages, BlockTypeDescriptionMessages } from '~/components/atoms';
import { Trans } from '@lingui/macro';

export const BlockTypes: React.FC<FieldProps> = ({ form }) => {
  const { loading, error, data, refetch, networkStatus } = useQuery(GET_BLOCK_TYPES, {
    notifyOnNetworkStatusChange: true,
  });

  return (
    <Fragment>
      {(loading || networkStatus === NetworkStatus.refetch) && (
        <Box alignItems={{ sm: 'center' }} justifyContent={{ sm: 'center' }} p={{ sm: '500' }} data-testid="loading">
          <Spinner size={SpinnerSize.LARGE} />
        </Box>
      )}
      {!loading && error && (
        <div data-testid="retry">
          <ErrorRetry refetch={refetch}>
            <Trans> There was a problem loading Block Type List. Please click the button below to try again.</Trans>
          </ErrorRetry>
        </div>
      )}
      {!loading && !error && (
        <div data-testid="success">
          {map(data.blockTypes, (blockType: BlockType) => {
            const selected = blockType.id === form.values.blockTypeId;
            const onClick = () => {
              form.setFieldValue('blockTypeId', blockType.id);
              form.setFieldTouched('blockTypeId', true);
            };

            return (
              <ListSelectionStyled key={blockType.id} onClick={onClick} data-testid={`block-type-${blockType.id}`}>
                <Box mr={{ sm: '500' }}>
                  <Radio checked={selected} readOnly />
                </Box>
                <Set spacing={SetSpacing.COMPACT} direction={SetDirection.COL}>
                  <Text size="400" weight="600" color="bechtel.grey.1000">
                    <Trans id={BlockTypeMessages[blockType.title].id} />
                  </Text>
                  <Text size="300" color="bechtel.grey.600">
                    <Trans id={BlockTypeDescriptionMessages[blockType.description].id} />
                  </Text>
                </Set>
              </ListSelectionStyled>
            );
          })}
        </div>
      )}
    </Fragment>
  );
};
